export default __webpack_public_path__ + "static/CCDE_desktop_1440x480-9b454ac60aca5ee9245689588b7b20b9.jpg";